import { GenerateMetadataResponse } from "./publish-models";

/** Repository for AI-generated publish metadata (programme, title, tags, category, rating, message). */
export abstract class IGenerateMetadataRepository {
  abstract generateMetadata(
    videoName: string,
    options?: { allowedRatings?: string[]; destination?: string },
  ): Promise<GenerateMetadataResponse>;
}
